import { CarouselItem } from '../../../models/item';
import { html } from 'lit-html';
import { each } from '../../../component';
import { PromotionDisplay, PromotionDisplayWithButton } from './promotion_display';
import {
  ItemImage,
  ItemLink,
  PriceArea,
  PriceAreaWithButton
} from '../../common/item_cassette/price_image_link';
import { ReviewArea, ReviewAreaWithoutReviewLink } from '../../common/item_cassette/review_area';
import { ButtonArea } from '../../common/item_cassette/button_area';

let isUserLogin: boolean;
/**
 * 共通部品、カルーセルの商品エリア
 */
export const CarouselItems = (
  carouselItems: CarouselItem[],
  isLogin: boolean,
  carouselId: string,
  perView: number = 6,
  analyticsClass: string = '',
  hasOrderAuthority: boolean = false
) => {
  isUserLogin = isLogin;
  const hasOrderAuthorityOrGuest = hasOrderAuthority || !isUserLogin;
  // バリエーション一覧ページのみボタンを表示する
  const carouselItemAreaForDisplay =
    isVariationPage(window.location.pathname) && hasOrderAuthorityOrGuest
      ? CarouselItemAreaWithButton
      : CarouselItemArea;
  return html`
    <div class="o-carousel js-lazy-img js-carousel -pagination" id="${carouselId}">
      <div
        class="swiper-container js-carousel-body"
        data-type="pagination"
        data-perview="${perView}"
        data-space="24"
      >
        <div class="swiper-wrapper">
          ${each(carouselItems, carouselItemAreaForDisplay, { analyticsClass: analyticsClass })}
        </div>
      </div>
      <div class="o-carousel_pagination js-carousel_pagination">
        ページ：
        <span class="o-carousel_count js-carousel_count"></span>
        <a href="#" class="a-textlink o-carousel_toFirst js-carousel_toFirst">最初に戻る</a>
      </div>
      <button class="a-ctrlbtn js-lazy-img -prev o-carousel_prev js-carousel_prev" type="button">
        <span class="a-ctrlbtn_text">前のスライドへ</span>
      </button>
      <button class="a-ctrlbtn js-lazy-img -next o-carousel_next js-carousel_next" type="button">
        <span class="a-ctrlbtn_text">次のスライドへ</span>
      </button>
    </div>
  `;
};

/**
 * バリエーション一覧ページ(/v/から始まる文字列)だったらtrueを返す
 * @param path window.location.pathname
 */
const isVariationPage = (path: string) => path.startsWith('/v/');

/**
 * カルーセル商品単品
 * @param carouselItem カルーセル-商品情報
 */
const CarouselItemArea = (
  carouselItem: CarouselItem,
  _index: number,
  _items: CarouselItem[],
  options: {
    [key: string]: string;
  }
) => html`
  <div class="o-carousel_slide swiper-slide js-carousel_slide">
    <div class="o-carousel_slideinner">
      <div class="m-simpleitemcard -vertical ${options['analyticsClass']}">
        <a
          href=${ItemLink(
            carouselItem.supplierId,
            carouselItem.itemCode,
            carouselItem.isVariation,
            carouselItem.rrLinkUrl
          )}
          title="${carouselItem.itemName}"
          class="m-simpleitemcard_link"
        >
          ${PromotionDisplay(carouselItem.promotionDisplayType)}
          <div class="m-simpleitemcard_img">
            <div class="a-img -radius">
              <span class="a-img_imgWrap">
                ${ItemImage(carouselItem.imageUrl, carouselItem.itemName)}
              </span>
            </div>
          </div>
          <div class="m-simpleitemcard_name">
            <p class="a-text u-maxline" data-maxline="3">${carouselItem.itemName}</p>
          </div>
        </a>
        ${ReviewArea(carouselItem)}
        ${PriceArea(
          carouselItem.salesPriceTaxInclude,
          carouselItem.isVariation,
          carouselItem.isMedical,
          isUserLogin
        )}
      </div>
    </div>
  </div>
`;

/**
 * カルーセル商品単品 ABTest
 * @param carouselItem カルーセル-商品情報
 */
const CarouselItemAreaWithButton = (
  carouselItem: CarouselItem,
  _index: number,
  _items: CarouselItem[],
  options: {
    [key: string]: string;
  }
) => html`
  <div class="o-carousel_slide swiper-slide js-carousel_slide">
    <div class="o-carousel_slideinner">
      <div class="m-itemcard -colHasTag ${options['analyticsClass']}">
        ${PromotionDisplayWithButton(carouselItem.promotionDisplayType)}
        <a
          href=${ItemLink(
            carouselItem.supplierId,
            carouselItem.itemCode,
            carouselItem.isVariation,
            carouselItem.rrLinkUrl
          )}
          title="${carouselItem.itemName}"
          class="m-itemcard_link"
        >
          <div class="m-itemcard_img">
            <div class="a-img">
              <span class="a-img_imgWrap">
                ${ItemImage(carouselItem.imageUrl, carouselItem.itemName)}
              </span>
            </div>
          </div>
        </a>
        ${ButtonArea(carouselItem)}
        <div class="m-itemcard_name">
          <a
            href=${ItemLink(
              carouselItem.supplierId,
              carouselItem.itemCode,
              carouselItem.isVariation,
              carouselItem.rrLinkUrl
            )}
            data-maxline="4"
            class="a-textlink u-maxline"
            >${carouselItem.itemName}</a
          >
        </div>
        <div class="m-itemcard_body">
          ${ReviewAreaWithoutReviewLink(carouselItem)}
          ${PriceAreaWithButton(
            carouselItem.salesPriceTaxInclude,
            carouselItem.isVariation,
            carouselItem.isMedical,
            isUserLogin
          )}
        </div>
      </div>
    </div>
  </div>
`;
